import { TemplatePreviewData } from "./types";

/**
 * Parse the rawFormData JSON string to extract preview information
 */
export const parseTemplatePreview = (
  rawFormData: string,
): TemplatePreviewData => {
  try {
    const parsed = JSON.parse(rawFormData);
    const form =
      parsed.productModificationForm || parsed.productCreationForm || {};

    // Helper to get value from a field object
    const getValue = (field: { value?: string } | undefined): string =>
      field?.value ?? "";

    // Helper to get selected option label from a select field
    const getSelectedOptionLabel = (field: {
      value?: string;
      options?: Array<{ id: string; value: string }>;
    }): string => {
      if (!field?.options || !field?.value) {
        return field?.value ?? "";
      }
      const option = field.options.find((opt) => opt.id === field.value);

      return option?.value ?? field.value;
    };

    return {
      customerNumber: getValue(form.customerNumber),
      structureNumber: getValue(form.structureNumber),
      productTypeCode: getValue(form.productTypeCode),
      registrationNumber: getValue(form.registrationNumber),
      vehicleType: getSelectedOptionLabel(form.vehicleType),
      fuelPackage: getSelectedOptionLabel(form.cardSettings?.fuelPackage),
      servicePackage: getSelectedOptionLabel(form.cardSettings?.servicePackage),
      customizableLine1: getValue(form.cardSettings?.customizableLine1),
      customizableLine2: getValue(form.cardSettings?.customizableLine2),
    };
  } catch (error) {
    console.error("Failed to parse template preview:", error);

    return {};
  }
};
